/**
 * StatTile: one figure with its label, on a Carbon Tile. Figures use tabular numbers. Optional `caption` (muted line
 * under the figure) and `href` (the label becomes a link to where the figure comes from).
 *
 * Props: `label`, `value` (already formatted), `caption`, `href`, `isLoading` (skeleton).
 */
import { Link, SkeletonText, Tile } from '@carbon/react';
import type { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router';
import './overview.scss';

export interface StatTileProps {
  label: ReactNode;
  value: ReactNode;
  caption?: ReactNode;
  href?: string;
  isLoading?: boolean;
}

export function StatTile({ label, value, caption, href, isLoading = false }: StatTileProps) {
  return (
    <Tile className="pos-stat-tile">
      <p className="pos-stat-tile__label">
        {href ? (
          <Link as={RouterLink} to={href}>
            {label}
          </Link>
        ) : (
          label
        )}
      </p>
      {isLoading ? <SkeletonText heading width="50%" /> : <p className="pos-stat-tile__value">{value}</p>}
      {/* A div: a caption may hold a Tag (a change against the period before), which can't sit in a paragraph. Always there,
          empty without one, so tiles with and without a caption are the same height. */}
      <div className="pos-stat-tile__caption">{!isLoading && caption}</div>
    </Tile>
  );
}
